import { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import VortexUserProfile from "./VortexUser/UserProfile";
import Sidebar from "../components/Sidebar/Sidebar";
import User from "./User/User";
import Content from "./Content/Content";
import Notifications from "./Notifications/Notifications";
import VortexNotification from "./VortexNotifications/Notifications";
import VortexAppManager from "./VotexAppManager/AppManager";
import UserProfile from "./User/UserProfile";
import Login from "./Login/Login";
import ForgotPassword from "./Login/forgot_password";
import DataAnalysis from "./DataAnalysis/DataAnalysis";
import Settings from "./Settings/Settings";
import Security from "./Security/Security";
import Reporting from "./Reporting/Reporting";
import AppManager from "./AppManager/AppManager";
import Email from "./Email/Email";
import VortexEmail from "./VortexEmail/Email";
import VortexDataAnalysis from "./VortexDataAnalysis/DataAnalysis";
import VortexUser from "./VortexUser/User";
import AccountReset from "./Login/accountReset";
import Register from "../register/Register";

const AuthorizedCom = () => {
  const [token, setToken] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("legacy");

  const handleTabChange = (tab) => {
    if (tab === "legacy") navigate("/");
    else if (tab === "vortex") navigate("/vortexData");
    setActiveTab(tab);
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      setToken(accessToken);
    } else if (
      location.pathname !== "/login" &&
      location.pathname !== "/forgot-password" &&
      location.pathname !== "/admin-account-reset" &&
      location.pathname !== "/register"
    ) {
      navigate("/login");
    }
  }, [navigate, location.pathname]);

  const isAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/admin-account-reset" ||
    location.pathname === "/register";

  if (isAuthPage) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin-account-reset" element={<AccountReset />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    );
  }

  return (
    <div style={{ minHeight: "100vh", width: "100%", backgroundColor: "black" }}>

      {/* ✅ Navbar — fixed, gets hamburger click handler */}
      <Navbar
        tab={activeTab}
        changeTab={handleTabChange}
        onMenuClick={() => setMobileOpen(true)}
      />

      {/* ✅ Below navbar — flex row, sidebar + content */}
      <div style={{
        display: "flex",
        paddingTop: "72px",      // matches navbar height
        minHeight: "100vh",
        alignItems: "stretch",
      }}>

        {/* ✅ Sidebar — always rendered, manages its own desktop/mobile display */}
        {activeTab === "legacy" && (
          <Sidebar
            mobileOpen={mobileOpen}
            setMobileOpen={setMobileOpen}
          />
        )}

        {/* ✅ Main content */}
        <main style={{
          flex: 1,
          overflowX: "hidden",
          backgroundColor: "black",
          minWidth: 0,  // prevents flex overflow
        }}>
          <Routes>
            <Route path="/" element={token ? <DataAnalysis /> : <Navigate to="/login" />} />
            <Route path="/user" element={<User />} />
            <Route path="/userProfile/:userId" element={<UserProfile />} />
            <Route path="/vortexuserProfile/:userId" element={<VortexUserProfile />} />
            <Route path="/content" element={<Content />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/security" element={<Security />} />
            <Route path="/reporting" element={<Reporting />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/AppManager" element={<AppManager />} />
            <Route path="/vortexappmanager" element={<VortexAppManager />} />
            <Route path="/vortexnotifications" element={<VortexNotification />} />
            <Route path="/Email" element={<Email />} />
            <Route path="/vortexData" element={<VortexDataAnalysis />} />
            <Route path="/vortexusers" element={<VortexUser />} />
            <Route path="/vortexemail" element={<VortexEmail />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AuthorizedCom;